// extracted by mini-css-extract-plugin
export var socialIcon = "Footer-module--social-icon--ec8a1";